import type { PostHog } from "posthog-js/dist/module.no-external";

import { onPosthog } from "$lib/core/posthog";

/** A reactive reference to the PostHog object, which is loaded asynchronously. */
export const posthogState = $state<{ current: PostHog | undefined }>({
  current: undefined,
});

onPosthog((newPosthog) => {
  posthogState.current = newPosthog;
});
